import { BackgroundStyled } from './Background.styled';

export const Background = ({ children }) => {
  return <BackgroundStyled>{children}</BackgroundStyled>;
};
